module.exports = __webpack_public_path__ + "img/LogoBlack.121e79f4.png";